<template>
  <form
      novalidate
      v-if="!showOverlay"
      v-on:submit.prevent="formValidated && requestQuote()"
      class="card border-0 py-3 px-2"
      style="max-width: 720px; margin: 0 auto">
    <div class="card-header bg-white d-flex align-items-center border-0">
      <h2 class="m-0 mr-auto font-weight-bold">Get A Moving Quote</h2>
    </div>
    <div class="card-body bg-white pb-0">
      <div class="row">
        <div class="col-sm">
          <div class="form-group">
            <label>Move Date</label>
            <div class="input-group d-flex">
              <Datepicker
                  name="proposedMoveDate"
                  style="flex: 1"
                  ref="arrivingCalendar"
                  input-class="form-control"
                  v-validate="'required'"
                  data-vv-validate-on="none"
                  v-model="moving.proposedMoveDate"
                  :disabled-dates="disabledDates"></Datepicker>
              <div class="input-group-append">
                <span class="input-group-text" @click="myCustomShowCalendar('arrivingCalendar')">
                  <i class="fa-calendar"></i>
                </span>
              </div>
            </div>
            <span
                v-show="errors.has('proposedMoveDate')"
                class="help is-danger">This field is required</span>
          </div>
        </div>
        <div class="col-sm">
          <div class="form-group">
            <label>Moving Sizes</label>
            <el-select
                name="moveSizeId"
                v-model="moving.moveSizeId"
                v-validate="'required'"
                data-vv-validate-on="none"
                placeholder="Select">
              <el-option
                  v-for="item in moveSizesComputed"
                  :key="item.id"
                  :label="item.text"
                  :value="item.id">
              </el-option>
            </el-select>
            <span
                v-show="errors.has('moveSizeId')"
                class="help is-danger">This field is required</span>
          </div>
        </div>
      </div>
      <hr class="separator" v-if="mode !== 'short'"/>
      <div class="row">
        <div class="col-sm">
          <div class="form-group">
            <label>Full Name</label>
            <input
                type="text"
                v-model="moving.name"
                class="form-control"
                name="name"
                v-validate="'required'"
                data-vv-validate-on="none"
                placeholder="Full Name" aria-label="Full Name">
            <span
                v-show="errors.has('name')"
                class="help is-danger">This field is required</span>
          </div>
        </div>
        <div class="col-sm">
          <div class="form-group">
            <label>Email</label>
            <input
                type="text"
                v-model="moving.email"
                name="email"
                v-validate="'required|email'"
                data-vv-validate-on="none"
                class="form-control"
                placeholder="Email" aria-label="Email">
            <span
                v-show="errors.has('email')"
                class="help is-danger">This field must be a valid Email address</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label>Phone Number</label>
            <input
                type="tel"
                v-model="moving.phone"
                name="phone"
                v-validate="'required|phoneNumber'"
                data-vv-validate-on="none"
                class="form-control"
                placeholder="Phone Number">
            <span
                v-show="errors.has('phone')"
                class="help is-danger">This field must be a valid phone number</span>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>Phone Type</label>
            <el-select
                name="phoneType"
                v-model="moving.phoneType"
                v-validate="'required'"
                data-vv-validate-on="none"
                placeholder="Select">
              <el-option
                  v-for="item in phoneTypes"
                  :key="item.id"
                  :label="item.text"
                  :value="item.id">
              </el-option>
            </el-select>
            <span
                v-show="errors.has('phoneType')"
                class="help is-danger">This field is required</span>
          </div>
        </div>
      </div>
      <hr class="separator" v-if="mode !== 'short'"/>
      <div class="row">
        <div class="col-sm">
          <div class="form-group">
            <label>Origin Address / Postal Code</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <i class="fa-map-marker"></i>
                </div>
              </div>
              <input
                  type="text"
                  v-model="moving.origin.fullAddress"
                  name="origin"
                  v-validate="'required'"
                  data-vv-validate-on="none"
                  class="form-control"
                  placeholder="Origin">
            </div>
            <span
                v-show="errors.has('origin')"
                class="help is-danger">This field is required</span>
          </div>
        </div>
        <div class="col-sm">
          <div class="form-group">
            <label>Destination Address / Postal Code</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <i class="fa-map-marker"></i>
                </div>
              </div>
              <input
                  type="text"
                  v-model="moving.destination.fullAddress"
                  name="destination"
                  v-validate="'required'"
                  data-vv-validate-on="none"
                  class="form-control"
                  placeholder="Destination">
            </div>
            <span
                v-show="errors.has('destination')"
                class="help is-danger">This field is required</span>
          </div>
        </div>
      </div>
      <div class="row" v-if="mode != 'short'">
        <div class="col-sm-3">
          <div class="form-group">
            <label>Stairs (Origin)</label>
            <el-select
                name="originFloors"
                v-model="moving.origin.numberOfFloors"
                v-validate="'required'"
                data-vv-validate-on="none"
                placeholder="Select">
              <el-option
                  v-for="item in floors"
                  :key="item"
                  :label="item"
                  :value="item">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="form-group">
            <label>Stairs (Destination)</label>

            <el-select
                name="destinationFloors"
                v-model="moving.destination.numberOfFloors"
                v-validate="'required'"
                data-vv-validate-on="none"
                placeholder="Select">
              <el-option
                  v-for="item in floors"
                  :key="item"
                  :label="item"
                  :value="item">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label>How did you hear about us?</label>
            <el-select
                name="referralSourceId"
                v-validate="'required'"
                data-vv-validate-on="none"
                v-model="moving.referralSourceId"
                collapse-tags
                style="margin-left: 20px;"
                placeholder="Select">
              <el-option
                  v-for="item in referralSourcesComputed"
                  :key="item.id"
                  :label="item.text"
                  :value="item.id">
              </el-option>
            </el-select>
            <span
                v-show="errors.has('referralSourceId')"
                class="help is-danger">This field is required</span>
          </div>
        </div>
      </div>
      <hr class="separator" v-if="mode !== 'short'">
      <div class="row" v-if="mode !== 'short'">
        <div class="col-sm">
          <div class="form-group">
            <label>Notes</label>
            <textarea
                v-model="moving.notes"
                name="notes"
                class="form-control"
                placeholder="Other notes"
            ></textarea>
          </div>
        </div>
      </div>
      <hr class="separator"/>
      <div class="row" v-if="moving.phoneType === 'mobile'">
        <div class="col-sm">
          <div class="form-group form-check">
            <input type="checkbox" class="form-check-input" id="userOptIn" v-model="moving.userOptIn">
            <label class="form-check-label" for="userOptIn">
              I agree to receive text messages related to this quote request. Standard messaging rates apply.
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer bg-white border-0">
      <button
          class="btn btn-primary btn-block p-3 font-weight-bold"
          :disabled="submitting || (!moving.userOptIn && moving.phoneType === 'mobile')"
          v-bind:style="buttonStyle">
        Get Estimate Now
      </button>
    </div>
  </form>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import $ from 'jquery';

export default {
  name: 'home',
  components: {
    Datepicker,
  },
  computed: {
    buttonStyle() {
      return {
        color: '#fff',
        'background-color': this.buttonColor,
        'border-color': this.buttonColor,
      };
    },
    moveSizesComputed() {
      return this.moveSizes.map(size => ({
        id: size.id,
        text: size.name,
      }));
    },
    referralSourcesComputed() {
      return this.referralSources.map(source => ({
        id: source.id,
        text: source.name,
      }));
    },
    floors() {
      return new Array(5).fill('').map((v, i) => i);
    },
    phoneTypes() {
      return [
        {
          id: 'home',
          text: 'Home',
        },
        {
          id: 'office',
          text: 'Office',
        },
        {
          id: 'mobile',
          text: 'Mobile',
        },
      ];
    },
    formValidated() {
      this.errors.clear();

      if (!this.moving.origin.fullAddress) {
        this.errors.add({ field: 'origin', msg: 'Missing' });
      }

      if (!this.moving.destination.fullAddress) {
        this.errors.add({ field: 'destination', msg: 'Missing' });
      }

      return true;
    },
  },
  data: () => ({
    submitting: false,
    mode: 'full',
    selected: '',
    buttonColor: '#146dc0',
    moveSizes: [],
    referralSources: [],
    mutiSelectOptions: {
      multiple: true,
      closeOnSelect: false,
    },
    moving: {
      companyId: '',
      proposedMoveDate: '',
      moveSizeId: '',
      name: '',
      email: '',
      phone: '',
      phoneType: '',
      userOptIn: false,
      origin: {
        numberOfFloors: 0,
        fullAddress: '',
      },
      destination: {
        numberOfFloors: 0,
        fullAddress: '',
      },
      specialtyItemIds: [],
      referralSourceId: null,
      referralUrl: '',
      notes: '',
    },
    disabledDates: {
      to: new Date(),
    },
    showOverlay: true,
    parentUrl: '',
  }),
  mounted() {
    this.mode = this.$route.query.mode || 'full';
    this.moving.companyId = this.$route.query.companyId;
    this.moving.branchId = this.$route.query.branchId;
    this.parentUrl = window.parent !== window ? document.referrer : '';
    $.ajax({
      url: [window.sm.url, 'public/quote-settings', this.$route.query.companyId].join('/'),
      method: 'GET',
      success: this.setup,
      error: () => {
        this.showOverlay = true;
      },
    });
  },
  methods: {
    myCustomShowCalendar(calendar) {
      if (this.$refs[calendar].isOpen) {
        return this.$refs[calendar].close();
      }

      if (!this.$refs[calendar].allowedToShowView('day')) {
        return false;
      }
      this.$refs[calendar].close();
      this.$refs[calendar].showDayView = true;
      if (!this.$refs[calendar].isInline) {
        setTimeout(() => {
          document.addEventListener('click', this.$refs[calendar].clickOutside, false);
        }, 100);
      }
      return false;
    },
    setup(response) {
      this.showOverlay = false;
      this.buttonColor = response.companySettings.buttonColor;
      this.moveSizes = response.moveSizes;
      this.referralSources = response.referralSources;

      // We'll need this in a second.
      window.sm.successPageCustomCode = response.successPageCustomCode;
      this.successPageCustomCode = response.successPageCustomCode;

      // Apply custom CSS if provided
      if (response.customCss) {
        this.injectCustomCss(response.customCss);
      }
    },
    injectCustomCss(cssContent) {
      // Remove any existing custom CSS
      const existingStyle = document.getElementById('custom-quote-form-css');
      if (existingStyle) {
        existingStyle.remove();
      }

      // Create and inject new style element
      const styleElement = document.createElement('style');
      styleElement.id = 'custom-quote-form-css';
      styleElement.type = 'text/css';
      styleElement.textContent = cssContent;
      document.head.appendChild(styleElement);
    },
    requestQuote() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return;
        }

        this.submitting = true;

        const form = {
          ...this.moving,
          parentUrl: this.parentUrl,
          formMode: this.mode,
        };

        let month = form.proposedMoveDate.getMonth() + 1;
        if (month < 10) {
          // eslint-disable-next-line
          month = '0' + month;
        }
        let day = form.proposedMoveDate.getDate();
        if (day < 10) {
          // eslint-disable-next-line
          day = '0' + day;
        }
        const dateKey = `${form.proposedMoveDate.getFullYear()}${month}${day}`;
        form.proposedMoveDate = dateKey;

        $.ajax({
          url: `${window.sm.url}/public/quotes`,
          method: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(form),
          success: () => this.$router.push('confirmation'),
          error: () => {
            this.submitting = false;
          },
        });
      });
    },
  },
};
</script>

<style lang="scss">
.form-control {
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  line-height: 1.25;
  color: #495057;
  background-color: #fff;
  background-image: none;
  background-clip: padding-box;
  border: 1px solid rgba(17, 17, 17, 0.15) !important;
  border-radius: 2px;
  box-shadow: none !important;
  line-height: 25px !important;
  transition: border-color ease-in-out 0.15s,
  box-shadow ease-in-out 0.15s;

  &::-ms-expand {
    background-color: transparent;
    border: 0;
  }

  &:focus {
    color: #495057;
    background-color: #fff;
    border-color: #65acef;
    outline: none;
  }

  &::placeholder {
    color: #868e96;
    opacity: 1;
  }

  &:disabled,
  &[readonly] {
    background-color: #d8d8d8;
    opacity: 1;
  }
}

.separator {
  border: solid 1px #ededed;
  background: transparent;
  height: 0px;
  margin-bottom: 25px;
}

.input-group-text {
  background: transparent !important;
  border-color: #d8d8d8 !important;
}

select.form-control {
  height: 43px !important;
}

label {
  font-size: 14px;
  opacity: 0.8;
  margin-bottom: 4px;
}

.custom-v-select {
  .dropdown-toggle {
    display: flex;

    input[type="search"] {
      min-width: 0;
      border: none !important;
    }

    .clear {
      display: none;
    }
  }
}

.col-sm-6, [class^="col-sm-"] {
  padding: 0 10px !important;
}

.is-danger {
  color: #e94b35;
}

.el-select {
  display: block;
  margin: 0 !important;
}
</style>
